import alea from "../images/alea.png"
import codeclause from "../images/codeclause_logo.jpeg";
import mydevteam from "../images/mydevteam_logo.jpeg";
import masai from "../images/masaischool_logo.jpeg";
import du from "../images/du.jpeg"
import tailwind from "../images/tailwind.jpeg"
export const Bio = {
  name: "Nandlal Saw",
  roles: [
    "Full Stack Developer",
    "Programmer",
    "Frontend Developer",
    "Backend Developer",
  ],
  description:
    "I'm a highly motivated and versatile individual with a strong aptitude for problem-solving and a deep commitment to continuous development. I enjoy tackling complex challenges, analyzing data, and developing effective solutions. I'm a firm believer in lifelong learning and actively pursue opportunities to expand my knowledge and skillset.",
  github: "https://github.com/NandlalShah955",
  gmail: "nandlalsaw789@gmail.com",
  resume:
    "https://drive.google.com/file/d/1yQkWUakT1sHQL8WavK40y1lvqszp2tHW/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/nandlal-saw-a2761822b/",

};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "ANT Design",
        image:
          "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://th.bing.com/th/id/OIP.BvCSQbGJNwGwfnsCiK-Y4gHaHa?w=152&h=180&c=7&r=0&o=5&dpr=1.25&pid=1.7",
      },
      {
        name: "NextJs",
        image:
          "https://th.bing.com/th/id/OIP.QMm8melj-4Qc0UfwN0aC_gHaHa?w=158&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
      },
     
      {
        name: "Tailwind CSS",
        image: tailwind,
      },
      
   
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://th.bing.com/th/id/OIP.b2Cmei85n1BpF-LRLBmcnwAAAA?w=143&h=143&c=7&r=0&o=5&dpr=1.3&pid=1.7",
      },
      {
        name: "Mongoose",
        image:
          "https://th.bing.com/th/id/OIP.X5BvMQ3BartCpY5n-2gCzgHaIK?w=166&h=183&c=7&r=0&o=5&dpr=1.3&pid=1.7",
      },
   
      {
        name: "PostGreSQL",
        image:
          "https://www.postgresql.org/media/img/about/press/elephant.png",
      },

      {
        name: "MongoDB",
        image:
          "https://chiranjeev-thapliyal.vercel.app/svg/mongodb.svg",
      },
     
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://images.seeklogo.com/logo-png/27/1/netlify-logo-png_seeklogo-273744.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "PostMan",
        image:
          "https://voyager.postman.com/logo/postman-logo-icon-orange.svg",
      },
      {
        name: "Jira",
        image:
          "https://cdn.worldvectorlogo.com/logos/jira-1.svg",
      },
      {
        name: "Render",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAe1BMVEX///8NDQ0AAACmpqbk5OT39/c5OTn8/PwbGxsHBwcPDw/19fUFBQUtLS1ubm7q6uq/v7/t7e2Li4vf39+Xl5dFRUU/Pz/Nzc01NTUjIyPJycmBgYEvLy9NTU2wsLBkZGShoaFqampYWFiZmZkmJia2trbX19d5eXmDg4MbGwgvAAAEkklEQVR4nO2ci1biMBCG26ElJC2UOwoCigi+/xPupEW8IaTprkm6/3eUwxEPzOckmWmbGkUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw9xH8JaLTQyupzFqr978gsiIpRm1LoxDl8MwWm8F6dre/v+/P19vnZVK95Dq6v4G2yIartSJNLmVePukOOomelS1wFKLo7HpEMn5D8bfkH9xND60wTDuzdz357qhioofxxHV4DeEEHdZE8U+wYyd1HaQtZW2PsqkiqX401I7bSbUYhTdcdczFgMenqkblZZSk2TIKshHQISe7D+vLRfTLtN+EKKhjTro/z8AqgVVyiTYhJpGH6C3BMzm9BNiPi2xrKshZ7C8DTOLKXJDr/yxxHW9thlwlbiwz7/CKOggpiXpKpVfq/AVDHqhBrTZcCsd1BLUjdYtwFFlwcqsQfsthTNNgBLXioGYKGfkQUhee1MpgXNV+enYddg3qzsJSkmaF67iNEfO8viE7Dl0HbszCIoUMHV0HbsyjpeF65DpyU/Z2hlIeXEduiqy7lJaoON+4jtyQiV0Kuf8OZSJuLA1j2gXSuHXI/KjiI1wRAzghpc+aWbRspxzOAzi1qA1tBQMx5KbU3rAbgqGIpu3OIWM9DeNAVpqi3sHvJ8N1ANVCRM+2KeQjxG0IhtnM2lDS1HX4JgytZyF3bd4fIOp1Yt7AsO/7mRohsmh5/XLhVWjr/SRMRTQjdeVq4VUUPboWuIVIxZCsMxjn974fAHM7k/byaxd8r+Qv1qdpvL/CJoRtO8NHW0qGcKrtxXod5clL28z7cn/oWfdruhj6f5E069uXQk7h0e9dbnpHzM5eUCm68/yUvtCrjH2tj6n34lrhBml6bDBE2XDs+yRMnxqUehYcZK4NfkCcNogmepGpr6hOD/SUusigELcXN5GWh6zLWtsS3tHFRUlJT3rj3u87pgYfWv4RsqNsMgeJVqnJX/MfYPCh+lcWM8qt56DiVbSTufGLXgzaRBEVRyJlK6jinLoHPdZ/XZE/b7Sn+bB6elpQxJuVKAPSLyRjqxlYboLWrSj1Hn9X7JPhg95Qv9Hbzb7MyLf9vNliq6wmoCqXGMlv/+zsom9lqIPYPw11FB8Mq6ejZLwuN6jbjFCp3/l+x+/srBXVK+RDXvaLzGA8/BxJMl11iei8BfaKC11EysFwEjm+paTY5/H51ghmP3jsaMbzKsgPY+6a3mvnO5tF+Qmub/RKvhzs5ecEGAxDpRcSonHic7P51bAuuVyNIietiilNDDmFOS3Kaeak4TSjgWFZ6ZKqaHp8UNTAUPKkDWDbdpMcSlq4Dt+AJvOQVh4PzjNNRikVLTek1xAEGxlOWm/odZE4Y29YnXZxHf9tGhh2wrgNvZFhEMAQhv4DQxj6Dwxh6D8whKH/wBCG/gNDGPoPDGHoPzCEof/AEIb+A0MY+g8MYeg/MISh/8AQhv7TdkPRdkN9S1Mvt/wHF6EYTnqXb3cxIBDDYt21pB/K/3fMUlsC2JcIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADThD0M3QQoPlWI+AAAAAElFTkSuQmCC",
      },

    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: mydevteam,
    role: "SDE-1",
    company: "MyDevTeam",
    date: "Jan 2025 - Present",
    desc: "Led frontend development for innovative web platforms, including a merchant rewards system that incentivizes businesses for every dollar processed via card payments. Designed and implemented role-based authentication (Super Admin, Merchant Admin, ISO Admin) with dedicated dashboards and granular authorization. Built fully responsive UIs using Tailwind CSS, implemented lazy loading for data-heavy tables, and integrated ANT Design (ANTD) components for scalable UI development.Additionally, contributed to a Music Distribution platform, enabling artists to upload music and digitally sign contracts",
    skills: [
      "ReactJS",
      "Redux",
      "TailwindCss",
      "HTML",
      "CSS",
      "JavaScript",
      "API Integration",
      "Ant Design",
      "Postman",
    ],
    
  },
  {
    id: 1,
    img: alea,
    role: "Mern Stack Developer",
    company: "AleaIt Solutions Pvt. Ltd.",
    date: "July 2023 - Nov 2024",
    desc: "Worked on diverse projects, including a multi-user platform with admin, super admin, and user roles, each with distinct access levels; a COGS and MRR management system integrating APIs and processing data from AWS S3 and Google Drive; a lead generation product featuring a custom survey builder with Rete.js and a Many Chat-like editor; and an Inventory/Patient Management System with Redux Toolkit, responsive UI, and robust API integrations for efficient catalog and profile management.",
    skills: [
      "ReactJS",
      "ReactNative",
      "Redux",
      "HTML",
      "CSS",
      "JavaScript",
      "API Integration",
      "Ant Design",
      "NextJs",
      "NodeJs",
      "ExpressJs",
      "MongoDB",
      "Mongoose",
      "Postman",
    ],
    
  },
  {
    id: 2,
    img: codeclause,
    role: "Web Developer Intern",
    company: "Code Clause",
    date: "May 2023 - July 2023",
    desc: "Contributed to different open-source projects and learn from industry experts",
    skills: [
      "ReactJS",
      "HTML",
      "CSS",
      "JavaScript",
      "API Integration",
      "NodeJs",
      "ExpressJs",
      "MongoDB"
    
    ],
  },
];

export const education = [
  {
    id: 0,
    img: masai,
    school: "Masai School",
    date: "April 2022 - Mar 2023",
    grade: " 8.1 CGPA",
    desc: "Done 1200+hours of Coding at Masai School with 80 mini and 10 Big Projects.Solved more than 200 DSA Q.100+hours of Soft SkillsActivities and societies: Done 1200+hours of Coding at Masai School with 80 mini and 10 Big Projects.Solved more than 200 DSA Q.100+hours of Soft Skills Masai School is a coding bootcamp that teaches you coding and make you job-ready in just a span of 7 months",
    degree: "Full Stack Web Development Course - Computer Science",
  },
  {
    id: 1,
    img: du,
    school: "Delhi University",
    date: "Aug 2019 - May 2022",
    grade: " 7.6 CGPA",
    desc: "Learned about our History,Politics of our international and our country.Gained knowledge on How our Economy WorksActivities and societies: Learned about our History,Politics of our international and our country.Gained knowledge on How our Economy Works Completed My graduation in 2022 .",
    degree: "Bachelor of Arts - B.A Programme, Economics",
  },
];

export const projects = [
  {
    id: 1,
    title: "Must Help Foundation",
    description:
      "Must Help Foundation is NGO which helps to celebrate your you to celebrate your birthdays, anniversaries, and other special occasions with underprivileged children and families ",
    image:
      "https://github.com/NandlalShah955/NandlalShah955.github.io/blob/main/stuff/images/Screenshot%202026-01-31%20185420.png?raw=true",
    tags: [
      "React.Js",
      "Redux",
      "Javascript",
      "CSS",
      "HTML"
    ],
    category: "web app",
    github: "https://github.com/NandlalShah955/Must-help-Foundation",
    webapp: "https://musthelp-foundation.netlify.app/",
  },
  {
    id: 2,
    title: "Chargebee Clone",
    description:
      "Chargebee is the subscription billing and revenue management platform that lets you solve for your today, and scale for your tomorrow.",
    image:
      "https://nandlalshah955.github.io/stuff/images/Chargbee.png",
    tags: [
      "NextJs",
      "Redux",
      "Chakra-UI",
      "NodeJs",
      "Mongoose",
      "Socket-IO",
      "MongoDB",
      "Express",
      "Nodemailer",
      "Javascript",
    ],
    category: "web app",
    github: "https://github.com/NandlalShah955/Charge-now-Clone",
    webapp: "https://abandoned-reaction-8426-dhamisir.vercel.app/",
  },
  {
    id: 3,
    title: "My Portfolio",
    description:
      "My Portfolio is a React.js application that serves as an online portfolio to showcase my work, skills, and achievements. It provides an overview of my background, displays my projects, and offers a way to contact me.",
    image:
      "https://raw.githubusercontent.com/NandlalShah955/NandlalShah955.github.io/refs/heads/main/stuff/images/Portfolioss.png",
    tags: [
      "React Js",
      "HTML5",
      "Tailwind CSS",
      "Javascript",
     
    ],
    category: "web app",
    github: "https://github.com/NandlalShah955/Personal-portfolio",
    webapp: "https://nandlalsaw-portfolio.netlify.app/",
  },
  {
    id: 4,
    title: "SkinStore Clone",
    description:
      "SkinStore is the online hub where beauty and science click, delivering the latest in innovative clinical skincare and luxury products for over 20 years.",
    image:
      "https://nandlalshah955.github.io/stuff/images/Skinstore.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Mongoose",
      "Chakra-UI", 
      "Javascript",
  
    ],
    category: "web app",
    github: "https://github.com/NandlalShah955/Skin-Store-Clone",
    webapp: "https://blossom-two.vercel.app/",
  },
  {
    id: 5,
    title: "Best Buy Clone",
    description:
      "Best Buy is an E-commerce website in this website we can purchase various products like Beauty Products , Dresses , Women Clothes and Accessories.",
    image:
      "https://nandlalshah955.github.io/stuff/images/Best-BUy-screenshot.png",
    tags: ["React Js", "Javascript", "CSS3","Github"],
    category: "web app",
    github: "https://github.com/NandlalShah955/Best-Buy.com-Clone",
    webapp: "https://bestbuyclonebynandlal.netlify.app/",
  },
  {
    id: 6,
    title: "Blue Mercury Clone",
    description:
      "A leader in luxury beauty and skincare, Purpose of BlueMercury is to create an inviting online beauty shopping experience.",
    image:
      "https://nandlalshah955.github.io/stuff/images/BlueMercury%20screenshot.png",
    tags: ["HTML", "Javascript","Local Storage","Github","CSS3"],
    category: "web app",
    github: "https://github.com/NandlalShah955/Blue-Mercury-Clone",
    webapp: "https://tiny-lamington-704c8c.netlify.app/",
  },
  {
    id: 7,
    title: "Balloon Mahal",
    description:
      "A Balloon Decoration Startup Business",
    image:
      "https://raw.githubusercontent.com/NandlalShah955/NandlalShah955.github.io/refs/heads/main/stuff/images/Screenshot%202024-12-28%20231607.png",
    tags: ["HTML", "Javascript","Local Storage","Github","CSS3"],
    category: "web app",
    github: "https://github.com/NandlalShah955/Blue-Mercury-Clone",
    webapp: "https://stately-profiterole-9f8d3b.netlify.app/",
  },
  
];

